import {createSvgIcon} from '@mui/material/utils';

export const PencilIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g>
        <line
            x1="3.86"
            y1="42.79"
            x2="41.55"
            y2="42.79"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <path
            d="M13.25,16.78h28.7a.5.5,0,0,1,.5.5v8.64a.5.5,0,0,1-.5.5H13.25a0,0,0,0,1,0,0V16.78a0,0,0,0,1,0,0Z"
            transform="translate(-6.35 30.08) rotate(-51.73)"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <path
            d="M14.63,30.39l-1.53,9.2a.44.44,0,0,0,.59.47l8.69-3.56"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <line
            x1="29.67"
            y1="12.3"
            x2="36.4"
            y2="17.6"
            fill="none"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
        <line
            x1="20.73"
            y1="30.59"
            x2="31.64"
            y2="16.81"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
        />
      </g>
    </svg>,
    'PencilIcon'
);